<template>
  <div id="app">
    <keep-alive
      :include="$store.state.includedComponents"
      :exclude="$store.state.excludedComponents"
    >
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import config from "@/conf";
import http from "@/utils/http";
import store from "@/vuex/state";
import storage from "@/utils/storage";
import axios from "axios";
import qs from "qs";

export default {
  name: "app",
  data() {
    return {
      wxconfig: {
        appId: "",
        timestamp: "",
        nonceStr: "",
        signature: "",
      },
      locationUrl: "",
      shareUrl: "", // 分享链接
      shareTitle: "意礴定制商城", // 分享标题
      shareDesc: "舒适不将就，为你定制专属鞋款！", // 分享描述
      shareImgUrl: `${config.domainname}/static/img/epoqueLogo.jpg`, // 分享图标
    };
  },
  components: {
    // loads,
  },
  methods: {
    // 跳转article时先获取数据 n
    async getArticleApiDetails(id, callback) {
      const self = this;
      // 弹窗进入的时候传issue_status=2，其他为1
      let res = await http.post("/v1/special/detail", { special_page: id });
      self.$store.state.articleApiDetails = res;
      callback(res);
    },
    async getweinsdkinfo() {
      const self = this;
      let res = await http.post("/v1/js.conf", { url: self.locationUrl });
      if (res.code == 200) {
        self.wxconfig.appId = res.data.appId;
        self.wxconfig.timestamp = res.data.timestamp;
        self.wxconfig.nonceStr = res.data.nonceStr;
        self.wxconfig.signature = res.data.signature;
        if (self.$route.path == "/article") {
          self.getArticleApiDetails(self.$route.query.specialId, (res) => {
            self.init();
          });
        } else {
          self.init();
        }
      }
    },
    init: function () {
      const self = this;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: self.wxconfig.appId, // 必填，公众号的唯一标识
        timestamp: self.wxconfig.timestamp, // 必填，生成签名的时间戳
        nonceStr: self.wxconfig.nonceStr, // 必填，生成签名的随机串
        signature: self.wxconfig.signature, // 必填，签名，见附录1
        jsApiList: [
          "onMenuShareAppMessage",
          "onMenuShareTimeline",
          "scanQRCode",
          "updateTimelineShareData",
          "updateAppMessageShareData",
        ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      wx.ready(function () {
        wx.updateTimelineShareData({
          title: self.shareTitle, // 分享标题
          desc: self.shareDesc, // 分享描述
          link: self.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: self.shareImgUrl, // 分享图标
          success: function () {
            // 用户确认分享后执行的回调函数
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          },
        });
        //分享给朋友
        wx.updateAppMessageShareData({
          title: self.shareTitle, // 分享标题
          desc: self.shareDesc, // 分享描述
          link: self.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: self.shareImgUrl, // 分享图标
          type: "", // 分享类型,music、video或link，不填默认为link
          dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
          success: function (e) {},
          cancel: function (e) {
            // 用户取消分享后执行的回调函数
            alert("cancel,取消分享");
            alert(e);
          },
          catch: function (e) {
            alert("catch,分享失败");
            alert(e);
          },
          error: function () {
            alert("error,分享信息错误");
            alert(e);
          },
        });
      });
      wx.error(function (res) {
        if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
          location.reload();
        }
      });
      wx.checkJsApi({
        jsApiList: [
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "scanQRCode",
          "updateTimelineShareData",
          "updateAppMessageShareData",
        ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function (res) {},
      });
    },
  },
  watch: {
    $route(to, from) {
      const self = this;
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        self.locationUrl = location.href;
      } else if (isIOS) {
        self.locationUrl = location.href.split("#")[0]; //hash后面的部分如果带上ios中config会不对
      } else {
        self.locationUrl = location.href.split("#")[0];
      }
      if (to.path.indexOf("detailsofthebnedition") > -1) {
        self.shareUrl = location.href.replace(
          /\/detailsofthebnedition\/.*?\?/,
          "/detailsofthebnedition?"
        );
      } else if (to.path == "/customArea") {
        self.shareUrl = location.href;
        self.shareTitle = "意礴最全定制攻略";
        self.shareDesc = "DIY材质和配色、选尺码和宽窄，打造你的专属鞋款";
        self.shareImgUrl = `${config.domainname}/static/img/epoqueLogo.jpg`;
      } else if (to.path == "/activity") {
        // 请求的
        // console.log('activity')
        self.shareUrl = location.href;
        let shareTitle = self.$store.state.detailApiDetails
          ? self.$store.state.detailApiDetails.share_title
          : storage.get("activityShareTitle");
        let shareDesc = self.$store.state.detailApiDetails
          ? self.$store.state.detailApiDetails.share_describe
          : storage.get("activityShareDescribe");
        let shareImgUrl = self.$store.state.detailApiDetails
          ? self.$store.state.detailApiDetails.share_image
          : storage.get("activityShareImage");
        self.shareTitle = shareTitle;
        self.shareDesc = shareDesc;
        self.shareImgUrl = shareImgUrl;
      } else if (to.path == "/article") {
        // 请求的
        self.shareUrl = location.href;
        let shareTitle = self.$store.state.articleApiDetails
          ? self.$store.state.articleApiDetails.share_title
          : storage.get("articleShareTitle");
        let shareDesc = self.$store.state.articleApiDetails
          ? self.$store.state.articleApiDetails.share_describe
          : storage.get("articleShareDescribe");
        let shareImgUrl = self.$store.state.articleApiDetails
          ? self.$store.state.articleApiDetails.share_image
          : storage.get("articleShareImage");
        self.shareTitle = shareTitle;
        self.shareDesc = shareDesc;
        self.shareImgUrl = shareImgUrl;
      } else if (to.path == "/getticket") {
        axios
          .post("/v1/special/detail", {
            special_page: to.query.specialId,
          })
          .then(function (res) {
            if (res.data.share_describe) {
              self.shareTitle = res.data.share_title;
              self.shareDesc = res.data.share_describe;
              self.shareImgUrl = res.data.share_image;
            }
          });
      } else if (to.path == "/coupondetailr" || to.path == "/couponReceive") {
        // 请求的
        let showName = encodeURI(to.query.showName);
        if (!to.query.couponType) {
          self.shareUrl = `${config.domainname}/#/couponReceive?recordId=${to.query.recordId}&showName=${showName}&parValue=${to.query.parValue}`;
          self.shareTitle = `送你一张${to.query.parValue - 0}元${decodeURI(
            showName
          )}`;
        } else {
          self.shareUrl = `${config.domainname}/#/couponReceive?recordId=${to.query.recordId}&showName=${showName}&parValue=${to.query.parValue}&couponType=3`;
          self.shareTitle = `送你一张${
            (to.query.parValue - 0) / 10
          }折${decodeURI(showName)}`;
        }
        self.shareDesc = `舒适不将就，为你定制专属鞋款!`;
        self.shareImgUrl = `${config.domainname}/static/img/epoqueLogo.jpg`;
      } else {
        self.shareUrl = `${config.domainname}`;
        self.shareTitle = "意礴定制商城";
        self.shareDesc = "舒适不将就，为你定制专属鞋款！";
        self.shareImgUrl = `${config.domainname}/static/img/epoqueLogo.jpg`;
      }
      if (
        localStorage.getItem("epoqueToken") &&
        localStorage.getItem("epoqueToken") != ""
      ) {
        this.getweinsdkinfo();
      }
    },
  },
  mounted() {},
};
</script>



// WEBPACK FOOTER //
// src/App.vue